var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HdNotifications',{staticClass:"deal-notifications",attrs:{"notifications":_vm.notifications},on:{"heightChange":_vm.onNotificationsHeightChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var notification = ref.notification;
return [_c('NotificationItem',{attrs:{"notification":notification,"loading":_vm.loading}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }